import axios from '../utils/axios';

export default function getJobseekerList(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/list-seekers`, { params })
        .then(response => {
            // Map the new response structure to match the old structure
            if (response.data && response.data.data && response.data.data.data) {
                return {
                    data: {
                        data: {
                            users: response.data.data.data.users
                        }
                    }
                };
            }
            return response;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};
